/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { Key } from 'react';
import { Text } from '@visiba-cortex/react-ui-std';
import { CountryFlag, AvailableCountryAssets } from '@components/country_flag.component';
import { tokens } from '@cellula/react-theme-patient';
import { Flex, InputSelect } from '@cellula/react';

export interface Language {
	key: string;
	code: string;
	nativeName: string;
}

interface Props {
	languages: Language[];
	defaultValue?: string;
	onChange?: (key: Key) => void;
}

export function LanguageSelect({ onChange, languages, defaultValue }: Props): JSX.Element {
	return (
		<InputSelect.Root
			label={/* TODO PAT-773 Should not be an empty string here, a11y issues */ ''}
			defaultValue={defaultValue}
			onValueChange={(value) => {
				onChange?.(value);
			}}
		>
			{languages.map((language) => (
				<InputSelect.Item value={language.code} key={language.code}>
					<Flex direction='row' align='center' gap={tokens.spacing.x1_5}>
						<CountryFlag code={language.code as AvailableCountryAssets} />
						<Text font={tokens.text.label.regular}>{language.nativeName}</Text>
					</Flex>
				</InputSelect.Item>
			))}
		</InputSelect.Root>
	);
}
